export const API_CONFIG = {
    WORD_PRESS_JSON: 'https://www.partyinyourgarden.co.uk/wp-json',
    QUOTE_TOOL_API: '/quote-tool-v2/v1',
    JET_CCT_API: '/jet-cct',
    JET_QUOTES_API: '/wp/v2/jet-quotes',
    GOOGLE_API: 'https://maps.googleapis.com/maps/api/place/autocomplete/json',
    GOOGLE_API_KEY: 'AIzaSyC9gQ8XeTNWjI4iYq1BxiGl4cxUZqKOqTo',
    ZAPIER_API: 'https://hooks.zapier.com/hooks/catch/1827147'
};
